export default "__VITE_ASSET__f2391159__"